import "line-awesome/dist/line-awesome/css/line-awesome.min.css";
import { Fragment } from "react";
import { Provider, useSelector } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import AnimationThemeProvider from "./_helper/AnimationTheme/AnimationThemeProvider";
import {
  default as CustomizerProvider,
  default as CustomProvider,
} from "./_helper/customizer/CustomizerProvider";
import "./App.css";
import { EBSSSProvider } from "./base/context/EBSSSContext";
import { TranslateProvider } from "./base/context/EBSSSLayoutContext";
import store, { persistor, ReduxDataKey } from "./base/store/store";
import Loader from "./Layout/Loader";
import Routers from "./Routes";
import { InjectorProvider } from "./base/context/EBSSSInjectorContext";

function App() {
  return (
    <Fragment>
      <Provider store={store}>
        <PersistGate loading={<Loader />} persistor={persistor}>
          <InjectorProvider>
            <TranslateProvider>
              <EBSSSProvider>
                <CustomizerProvider>
                  <CustomProvider>
                    <AnimationThemeProvider>
                      <Routers />
                    </AnimationThemeProvider>
                  </CustomProvider>
                </CustomizerProvider>
              </EBSSSProvider>
            </TranslateProvider>
          </InjectorProvider>
        </PersistGate>
      </Provider>
    </Fragment>
  );
}
export default App;
